module.exports = __webpack_public_path__ + "static/media/Space_02.0af468f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lms/Space_02.jpg
// module id = 414
// module chunks = 0